import { Crud, HttpClient, httpClient } from 'lib/HttpClient';
import { MenuOptionOverrides } from './MenuOptionsModel';

const defaultHeaders = {
    'x-auth-id': import.meta.env.CONSOLE_FIREBASE_PROJECT_ID,
    'x-api-version': 5
};
class MenuOptionsApi extends Crud {
    constructor(client: HttpClient) {
        super(client, import.meta.env.MENU_SERVICE_URL, 'menuoptions', defaultHeaders);
    }

    getMenuOptionsByLocation(locationId: string) {
        return this.getList({
            queryParameters: [{ key: 'locationId', value: locationId }]
        });
    }

    updateMenuOptionOverrides(locationId: string, payload: MenuOptionOverrides[]) {
        return this.httpClient.put(
            `${import.meta.env.MENU_SERVICE_URL}/menuoptions/${locationId}/overrides`,
            {
                body: payload,
                headers: defaultHeaders,
                skipResponseBody: true
            }
        );
    }
}

export const menuOptionsApi = new MenuOptionsApi(httpClient);
